import { render, staticRenderFns } from "./guidanceIndex.vue?vue&type=template&id=2fa56538&scoped=true&"
import script from "./guidanceIndex.vue?vue&type=script&lang=js&"
export * from "./guidanceIndex.vue?vue&type=script&lang=js&"
import style0 from "./guidanceIndex.vue?vue&type=style&index=0&id=2fa56538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa56538",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa56538')) {
      api.createRecord('2fa56538', component.options)
    } else {
      api.reload('2fa56538', component.options)
    }
    module.hot.accept("./guidanceIndex.vue?vue&type=template&id=2fa56538&scoped=true&", function () {
      api.rerender('2fa56538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/newGuidance/guidanceIndex.vue"
export default component.exports